import { createFileRoute } from "@tanstack/react-router";

import EmailChangeTokenPage from "@/features/auth/pages/email-change-verify";

interface TokenSearch {
  // Arrives from the verification email: <appBaseUrl>/email-change/verify?token=...
  token?: string;
}

export const Route = createFileRoute("/(auth)/email-change/verify")({
  component: () => (
    <main role="main" aria-label="Confirm email change" className="min-h-screen w-full">
      <EmailChangeTokenPage mode="verify" />
    </main>
  ),
  validateSearch: (search: Record<string, unknown>): TokenSearch => ({
    token: search.token as string | undefined,
  }),
});
